import { tableName } from "app/area/case/case-data-model";
import { getAllEntitiesAtPath } from "app/infrastructure/store";
import { caseDataToStore } from "app/infrastructure/store/normalize";
import { CodetableWireFormat } from "app/infrastructure/ui/form/types-codetable";
import { CaseData } from "app/types-shared";
import { ComplexValue } from "ui";

export const mapStatusCode = (code: CodetableWireFormat): ComplexValue<number> => ({
  value: code.v,
  description: code.d,
  backgroundColor: code.b  
});

export const connectedCasesIdsByConnectionType = (caseData: CaseData) => {
  const allConnectedCases = getAllEntitiesAtPath(
    caseDataToStore(caseData),
    [tableName.trans, tableName.connectionTypes, tableName.connectedCases]
  );
  const results = allConnectedCases.reduce((result, e) => {
    const connectionType = e.id.find(i => i[tableName.connectionTypes]);
    if (connectionType) {
      const key = connectionType[tableName.connectionTypes];
      result[key] = result[key] || [];
      result[key].push(e.primaryKey.value);
    }
    return result;
  }, {});
  return results;
};
